import { render, staticRenderFns } from "./ShipmentSvg.vue?vue&type=template&id=f26b5e5a"
import script from "./ShipmentSvg.vue?vue&type=script&lang=js"
export * from "./ShipmentSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports